import Block from '../../../../_base/src/components/block/index'

import Lenis from 'lenis'

export default class PageBody extends Block {
	static title = 'page-body'

	// the page has a single scroller, so the instance is shared instead of
	// created per matching element
	static lenis = null

	constructor($el) {
		super($el)

		if (PageBody.lenis) {
			return
		}

		// touch keeps its native scrolling, reduced motion is handled by lenis
		PageBody.lenis = new Lenis({
			autoRaf: true,
			lerp: 0.16,
			anchors: true,
			allowNestedScroll: true,
		})

		this.lenis = PageBody.lenis

		// other components lock the page (popups, overlays) through these events
		$(document)
			.on('scroll:stop', () => this.lenis.stop())
			.on('scroll:start', () => this.lenis.start())
			.on('scroll:to', (event, target, options) =>
				this.lenis.scrollTo(target, options),
			)
	}
}
